import React, { useState } from 'react';
import { Stepper, GetInfo } from '@operations/shared';
import SubmitNewDiscount from './SubmitNewDiscount';
import ViewAdvances from './ViewAdvances';
import { userActiveAdvancesApi } from '../../../utils/apisConsts';

export const ViewSubmitNewDiscount: React.FC = () => {
    const [componentSteps] = useState([
        {
            title: 'Get User',
            content: <GetInfo apiLink={userActiveAdvancesApi} isApplyingPhoneAndID />,
            id: 0,
        },
        {
            title: 'View Advances',
            content: <ViewAdvances />,
            id: 1,
        },
        {
            title: 'Add Discount',
            content: <SubmitNewDiscount />,
            id: 2,
        },
    ]);

    return (
        <>
            <Stepper componentSteps={componentSteps} />
        </>
    );
};

